import { BLOGS_API } from 'modules/blogs/api/blog-api'
import { BlogInterface } from 'modules/blogs/types/blog-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

interface UseBlogInterface {
  id: string
}

export function useBlog({ id }: UseBlogInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, BlogInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: blog, mutate: blogMutate } = useSWR(() => {
    if (user) {
      return `${BLOGS_API}/${id}`
    }
    return null
  }, fetcher)

  return { blog, blogMutate }
}
